import * as React from "react";
import { useLocation, Link } from 'react-router-dom';
import "./index.css"

export const HomeLink: React.FC = () => {
    
const location  = useLocation().pathname;
//console.log( location );

  
    if ( location === "/queries" ) {
        return (
            <div className="homelink-container">
                <div className="navigation-inactive">Codelist</div>
            </div>
        )
    } 

    return (    
      <div className="homelink-container">
        <Link to="/queries" className="navigation">Codelist</Link>
      </div>
    )
  }
